import { createContext } from 'react'

const EditContainerCloseContext = createContext<(() => void) | null>(null)

export default EditContainerCloseContext
